<template lang="pug">
.gender-radio
  .md-subheading Gender
  md-radio.md-primary(
    v-for='gender in genders',
    v-model='selected',
    :md-value='gender.key',
    @change='onGenderChange',
    :key='gender'
  ) {{ gender.value }}
</template>

<script>
  import { metrics } from '../../assets/data/demographics';

  export default {
    props: {
      value: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        selected: this.value,
        genders: metrics.sexes
      };
    },
    methods: {
      onGenderChange(gender) {
        this.$emit('input', gender);
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/demographic/GenderRadio.vue